export default "__VITE_ASSET__85831f60__"